/**
 * Куда вести после входа (и, KAN-925, после переключения аккаунта или выхода
 * из одного аккаунта: правила те же, что у обычного входа).
 */
import { isMobileAppPath, isPhoneDevice, MOBILE_HOME, MOBILE_LOGIN_PATH } from './mobileApp';

export const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

/**
 * KAN-881: адрес, сохранённый AuthGuard, забирается один раз. Годится только
 * адрес этого сайта: разбираем URL-парсером и сверяем origin (ручные проверки
 * пропускали "/<таб>/evil.example", который парсер читает как //evil.example).
 */
export function takeRedirectAfterLogin(): string | null {
  let saved: string | null = null;
  try {
    saved = localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
    localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
  } catch {
    return null;
  }
  if (!saved) return null;
  try {
    const url = new URL(saved, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}

/**
 * KAN-854: менеджер с телефона после входа уходит в приложение, остальные на
 * дашборд. KAN-881: менеджер шёл в CRM кабинета с ?desktop=1 (на iPhone
 * "Полная CRM" открывается в Safari без входа): ведём туда, а не в приложение.
 * Смотрим только параметр в самом сохранённом адресе, не флаг вкладки.
 */
export function pathAfterLogin(isManager: boolean, saved: string | null = null): string {
  if (!isManager) return '/';
  if (saved && new URLSearchParams(new URL(saved, window.location.origin).search).get('desktop') === '1') {
    return saved;
  }
  return isPhoneDevice() ? MOBILE_HOME : '/';
}

/** KAN-925: страница входа, когда вошедших не осталось: приложение на свою форму. */
export function loginPathAfterLogout(pathname: string): string {
  return isMobileAppPath(pathname) ? MOBILE_LOGIN_PATH : '/login';
}

/** KAN-925: режим "Добавить аккаунт" страницы входа кабинета. */
export const ADD_ACCOUNT_PATH = '/login?add=1';

export function isAddAccountSearch(search: string): boolean {
  return new URLSearchParams(search).get('add') === '1';
}
